export class RevenuePostAdjustments {
    public constructor(init?: Partial<RevenuePostAdjustments>) {
      Object.assign(this, init);
    }
      revenuePostAdjustmentId: number;
      revenueAdjustmentId: number;
      invoiceNumber: string;
      revenueType: string;
      adjustedAmount: number;
      adjustmentReasonId: number;
      adjustedTaxAmount: number;
      userName: string;
      isLocked: boolean;
      dateEntered: Date;
      lotNumber: string;

   }